





















































































































































import { Component, Mixins } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { MenuCategory, MenuItem } from '@/tcw/domain/types'
import Logout from '@/components/login/Logout.vue'
import Getsudo from '@/tcw/domain/Getsudo'

@Component({
  components: { Logout }
})
export default class TcwLayoutBasicHeader extends Mixins(BaseComponent) {
  private rootLink = '/'
  private logoutModalOpen = false

  private hasShouninTask(): boolean {
    return this.countShouninTask() > 0
  }

  private get menuItems(): MenuCategory[] {
    const menuItems = [
      {
        categoryId: '1',
        label: '勤怠',
        items: [
          { id: '1-1', label: '勤怠一覧', link: '/kintai/list' },
          { id: '1-2', label: '勤怠入力', action: () => this.gotoTodaysPage('/kintai/input') },
          { id: '1-3', label: '交通費', action: () => this.gotoTodaysPage('/koutsuhi/input') },
          { id: '1-4', label: 'タイムカード', action: () => this.gotoTodaysPage('/timecard') }
        ]
      },
      {
        categoryId: '2',
        label: '提出/承認',
        alert: this.hasShouninTask,
        items: [
          { id: '2-1', label: '今月の勤怠提出', link: '/teishutsu/last' },
          { id: '2-2', label: '提出履歴', link: '/teishutsu/history' },
          {
            id: '2-3',
            label: '承認依頼',
            link: '/shounin/tasks',
            badge: this.countShouninTask
          },
          {
            id: '2-4',
            label: 'メンバ提出状況',
            link: `/teishutsu/member/status/${Getsudo.last(this.shimebi).toString()}`
          }
        ]
      },
      {
        categoryId: '4',
        label: 'エクスポート',
        items: [{ id: '4-1', label: 'Excel', link: '/excel' }]
      },
      {
        categoryId: '3',
        label: '設定',
        items: [
          { id: '3-1', label: 'プロジェクト設定', link: '/settei/project' },
          { id: '3-2', label: '勤怠パターン', link: '/pattern/kintai/list' },
          { id: '3-3', label: '交通費パターン', link: '/pattern/koutsuhi/list' },
          { id: '3-4', label: '承認ルート設定', link: '/settei/shounin/route' }
        ]
      },
      {
        categoryId: '9',
        label: 'ヘルプ',
        items: [
          { id: '9-1', label: 'ヘルプ', action: this.jumpHelpPage },
          { id: '9-2', label: 'フォーラム', link: '/forum' },
          { id: '9-3', label: '問い合わせ', link: '/toiawase' }
        ]
      }
    ]

    // 管理者メニュー表示する
    if (this.$tcw.session.role === 'ADMIN') {
      menuItems.push({
        categoryId: '5',
        label: '管理者メニュー',
        items: [
          { id: '5-1', label: 'ユーザ管理', link: '/user/list' },
          { id: '5-2', label: 'システム設定', link: '/settei/system' },
          { id: '5-3', label: 'メンテナンス', link: '/maintenance' }
        ]
      })
    }
    return menuItems
  }

  private setteiMenus: MenuItem[] = [
    { id: 'settei1', label: 'アカウント', link: '/settei/user' },
    { id: 'settei2', label: '個人設定', link: '/settei/list' }
  ]

  private async confirmAppUpdate(): Promise<void> {
    const res = await this.$tcw.confirm({
      type: 'warning',
      title: '最新バージョンがあります',
      message:
        'アプリを最新バージョンに更新してください。<br>更新しない場合、アプリが正常に動作しない場合があります。',
      confirmText: '更新する'
    })
    if (res) {
      await this.reloadApp()
    }
    return
  }

  /**
   * ヘルプページへ遷移する
   */
  private jumpHelpPage(): void {
    if (this.isFirstLoginFlow) {
      // 初回ログインフロー時
      const jumpUrl = this.tcw.getFirstLoginFlowHelpUrl()
      window.open(jumpUrl, '_blank')
    } else {
      // 通常時
      const jumpUrl = this.tcw.getHelpUrlByRoute(this.$route)
      window.open(jumpUrl, '_blank')
    }
  }

  private gotoTodaysPage(link: string) {
    // ストアのcurrentDateに現在の日付を設定
    this.$tcw.$store.basic.setTargetDate(this.du.now())
    this.$router.push(link)
  }
}
